// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button {
  width: 100%;
  min-height: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: var(--white-color-light);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  transition: all 0.3s;
  border: none;
  padding: 8px;
  border-radius: 8px;
  font-weight: 600;
  letter-spacing: 2px;
  font-size: 16px;
}
.button .button-label {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  line-height: 24px;
}
.button:hover {
  cursor: pointer;
}
.button.medium {
  min-height: 48px;
}
.button.hidden {
  color: var(--dark-color-dark);
  border-radius: 8px;
  background-color: transparent;
}
.button.hidden:hover {
  background-color: var(--dark-color-dark-transparent-10);
}
.button.hidden:disabled, .button.hidden.disabled {
  background-color: transparent;
  pointer-events: none;
}
.button.hidden-border {
  border: 1px solid var(--border-weak-color);
  color: var(--font_active_sub_color);
  border-radius: 8px;
  background-color: transparent;
}
.button.hidden-border:hover {
  border: 1px solid var(--border-color);
  background-color: var(--dark-color-dark-transparent-10);
}
.button.hidden-border:disabled, .button.hidden-border.disabled {
  background-color: transparent;
  pointer-events: none;
}
.button.primary {
  border: 1px solid var(--primary-color-main);
  background-color: var(--primary-color-main);
}
.button.primary:hover {
  background-color: var(--primary-color-dark);
  border: 1px solid var(--primary-color-dark);
}
.button.primary:disabled, .button.primary.disabled {
  border: 1px solid var(--primary-color-disabled);
  background-color: var(--primary-color-disabled);
  pointer-events: none;
}
.button.primary-border {
  color: var(--primary-color-main);
  border: 1px solid var(--primary-color-main);
  background-color: transparent;
}
.button.primary-border:hover {
  color: var(--white-color-light);
  background-color: var(--primary-color-main);
}
.button.primary-border:disabled, .button.primary-border.disabled {
  border: 1px solid var(--disabled-border-color);
  background-color: transparent;
  pointer-events: none;
  color: var(--disabled-font-color);
}
.button.secondary {
  color: var(--font_active_sub_color);
  border: 1px solid var(--dark-color-light);
  background-color: var(--dark-color-light);
}
.button.secondary:hover {
  background-color: var(--dark-color-main);
  border: 1px solid var(--dark-color-main);
}
.button.secondary:disabled, .button.secondary.disabled {
  border: 1px solid var(--disabled-border-color);
  background-color: var(--disabled-bg-color);
  pointer-events: none;
  color: var(--disabled-font-color);
}
.button.secondary-border {
  color: var(--font_active_sub_color);
  border: 1px solid var(--border-color);
  background-color: transparent;
}
.button.secondary-border:hover {
  background-color: var(--dark-color-dark-transparent-10);
}
.button.secondary-border:disabled, .button.secondary-border.disabled {
  border: 1px solid var(--disabled-border-color);
  background-color: transparent;
  pointer-events: none;
  color: var(--disabled-font-color);
}
.button.danger {
  border: 1px solid var(--danger-color-main);
  background-color: var(--danger-color-main);
}
.button.danger:hover {
  background-color: var(--danger-color-dark);
  border: 1px solid var(--danger-color-dark);
}
.button.danger:disabled, .button.danger.disabled {
  border: 1px solid var(--danger-color-disabled);
  background-color: var(--danger-color-disabled);
  pointer-events: none;
}
.button.danger-border {
  color: var(--danger-color-main);
  border: 1px solid var(--danger-color-main);
  background-color: transparent;
}
.button.danger-border:hover {
  color: var(--white-color-light);
  background-color: var(--danger-color-main);
}
.button.danger-border:disabled, .button.danger-border.disabled {
  border: 1px solid var(--disabled-border-color);
  background-color: transparent;
  pointer-events: none;
  color: var(--disabled-font-color);
}
.button.warning {
  border: 1px solid var(--warning-color-main);
  background-color: var(--warning-color-main);
}
.button.warning:hover {
  background-color: var(--warning-color-dark);
  border: 1px solid var(--warning-color-dark);
}
.button.warning:disabled, .button.warning.disabled {
  border: 1px solid var(--warning-color-disabled);
  background-color: var(--warning-color-disabled);
  pointer-events: none;
}
.button.warning-border {
  color: var(--warning-color-main);
  border: 1px solid var(--warning-color-main);
  background-color: transparent;
}
.button.warning-border:hover {
  color: var(--white-color-light);
  background-color: var(--warning-color-main);
}
.button.warning-border:disabled, .button.warning-border.disabled {
  border: 1px solid var(--warning-color-disabled);
  pointer-events: none;
}
.button.success {
  border: 1px solid var(--success-color-main);
  background-color: var(--success-color-main);
}
.button.success:hover {
  background-color: var(--success-color-dark);
  border: 1px solid var(--success-color-dark);
}
.button.success:disabled, .button.success.disabled {
  border: 1px solid var(--success-color-disabled);
  background-color: var(--success-color-disabled);
  pointer-events: none;
}
.button.success-border {
  color: var(--success-color-main);
  border: 1px solid var(--success-color-main);
  background-color: transparent;
}
.button.success-border:hover {
  color: var(--white-color-light);
  background-color: var(--success-color-main);
}
.button.success-border:disabled, .button.success-border.disabled {
  border: 1px solid var(--success-color-disabled);
  pointer-events: none;
}
.button.white {
  color: var(--font_active_color);
  border: 1px solid var(--white-color-lightest);
  background-color: var(--white-color-lightest);
}
.button.white:hover {
  background-color: var(--white-color-light);
  border: 1px solid var(--white-color-light);
}
.button.white-border {
  color: var(--font_active_color);
  border: 1px solid var(--white-color-lightest);
  background-color: transparent;
}
.button.white-border:hover {
  background-color: var(--dark-color-dark-transparent-10);
}`, "",{"version":3,"sources":["webpack://./src/_core/components/common/UI/Button.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,oBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EAEA,gBAAA;EACA,mBAAA;EACA,eAAA;AAAF;AAEE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AAAJ;AAGE;EACE,eAAA;AADJ;AAIE;EACE,gBAAA;AAFJ;AAKE;EACE,6BAAA;EACA,kBAAA;EACA,6BAAA;AAHJ;AAII;EACE,uDAAA;AAFN;AAKI;EACE,6BAAA;EACA,oBAAA;AAHN;AAME;EACE,0CAAA;EACA,mCAAA;EACA,kBAAA;EACA,6BAAA;AAJJ;AAKI;EACE,qCAAA;EACA,uDAAA;AAHN;AAMI;EACE,6BAAA;EACA,oBAAA;AAJN;AAQE;EACE,2CAAA;EACA,2CAAA;AANJ;AAQI;EACE,2CAAA;EACA,2CAAA;AANN;AASI;EACE,+CAAA;EACA,+CAAA;EACA,oBAAA;AAPN;AAWE;EACE,gCAAA;EACA,2CAAA;EACA,6BAAA;AATJ;AAWI;EACE,+BAAA;EACA,2CAAA;AATN;AAYI;EACE,8CAAA;EACA,6BAAA;EACA,oBAAA;EACA,iCAAA;AAVN;AAcE;EACE,mCAAA;EACA,yCAAA;EACA,yCAAA;AAZJ;AAcI;EACE,wCAAA;EACA,wCAAA;AAZN;AAeI;EACE,8CAAA;EACA,0CAAA;EACA,oBAAA;EACA,iCAAA;AAbN;AAiBE;EACE,mCAAA;EACA,qCAAA;EACA,6BAAA;AAfJ;AAiBI;EACE,uDAAA;AAfN;AAkBI;EACE,8CAAA;EACA,6BAAA;EACA,oBAAA;EACA,iCAAA;AAhBN;AAoBE;EACE,0CAAA;EACA,0CAAA;AAlBJ;AAoBI;EACE,0CAAA;EACA,0CAAA;AAlBN;AAqBI;EACE,8CAAA;EACA,8CAAA;EACA,oBAAA;AAnBN;AAuBE;EACE,+BAAA;EACA,0CAAA;EACA,6BAAA;AArBJ;AAuBI;EACE,+BAAA;EACA,0CAAA;AArBN;AAwBI;EACE,8CAAA;EACA,6BAAA;EACA,oBAAA;EACA,iCAAA;AAtBN;AA0BE;EACE,2CAAA;EACA,2CAAA;AAxBJ;AA0BI;EACE,2CAAA;EACA,2CAAA;AAxBN;AA2BI;EACE,+CAAA;EACA,+CAAA;EACA,oBAAA;AAzBN;AA6BE;EACE,gCAAA;EACA,2CAAA;EACA,6BAAA;AA3BJ;AA6BI;EACE,+BAAA;EACA,2CAAA;AA3BN;AA8BI;EACE,+CAAA;EACA,oBAAA;AA5BN;AAgCE;EACE,2CAAA;EACA,2CAAA;AA9BJ;AAgCI;EACE,2CAAA;EACA,2CAAA;AA9BN;AAiCI;EACE,+CAAA;EACA,+CAAA;EACA,oBAAA;AA/BN;AAmCE;EACE,gCAAA;EACA,2CAAA;EACA,6BAAA;AAjCJ;AAmCI;EACE,+BAAA;EACA,2CAAA;AAjCN;AAoCI;EACE,+CAAA;EACA,oBAAA;AAlCN;AAsCE;EACE,+BAAA;EACA,6CAAA;EACA,6CAAA;AApCJ;AAsCI;EACE,0CAAA;EACA,0CAAA;AApCN;AAwCE;EACE,+BAAA;EACA,6CAAA;EACA,6BAAA;AAtCJ;AAwCI;EACE,uDAAA;AAtCN","sourcesContent":[".button {\n  width: 100%;\n  min-height: 40px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  color: var(--white-color-light);\n  text-align: center;\n  text-decoration: none;\n  vertical-align: middle;\n  transition: all 0.3s;\n  border: none;\n  padding: 8px;\n  border-radius: 8px;\n\n  font-weight: 600;\n  letter-spacing: 2px;\n  font-size: 16px;\n\n  .button-label{\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    line-height: 24px;\n  }\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  &.medium{\n    min-height: 48px;\n  }\n\n  &.hidden{\n    color: var(--dark-color-dark);\n    border-radius: 8px;\n    background-color: transparent;\n    &:hover{\n      background-color: var(--dark-color-dark-transparent-10);\n    }\n\n    &:disabled, &.disabled{\n      background-color: transparent;\n      pointer-events: none;\n    }\n  }\n  &.hidden-border{\n    border: 1px solid var(--border-weak-color);\n    color: var(--font_active_sub_color);\n    border-radius: 8px;\n    background-color: transparent;\n    &:hover{\n      border: 1px solid var(--border-color);\n      background-color: var(--dark-color-dark-transparent-10);\n    }\n\n    &:disabled, &.disabled{\n      background-color: transparent;\n      pointer-events: none;\n    }\n  }\n\n  &.primary{\n    border: 1px solid var(--primary-color-main);\n    background-color: var(--primary-color-main);\n\n    &:hover{\n      background-color: var(--primary-color-dark);\n      border: 1px solid var(--primary-color-dark);\n    }\n\n    &:disabled, &.disabled{\n      border: 1px solid var(--primary-color-disabled);\n      background-color: var(--primary-color-disabled);\n      pointer-events: none;\n    }\n  }\n\n  &.primary-border{\n    color: var(--primary-color-main);\n    border: 1px solid var(--primary-color-main);\n    background-color: transparent;\n\n    &:hover{\n      color: var(--white-color-light);\n      background-color: var(--primary-color-main);\n    }\n\n    &:disabled, &.disabled{\n      border: 1px solid var(--disabled-border-color);\n      background-color: transparent;\n      pointer-events: none;\n      color: var(--disabled-font-color);\n    }\n  }\n\n  &.secondary{\n    color: var(--font_active_sub_color);\n    border: 1px solid var(--dark-color-light);\n    background-color: var(--dark-color-light);\n\n    &:hover{\n      background-color: var(--dark-color-main);\n      border: 1px solid var(--dark-color-main);\n    }\n\n    &:disabled, &.disabled{\n      border: 1px solid var(--disabled-border-color);\n      background-color: var(--disabled-bg-color);\n      pointer-events: none;\n      color: var(--disabled-font-color);\n    }\n  }\n\n  &.secondary-border{\n    color: var(--font_active_sub_color);\n    border: 1px solid var(--border-color);\n    background-color: transparent;\n\n    &:hover{\n      background-color: var(--dark-color-dark-transparent-10);\n    }\n\n    &:disabled, &.disabled{\n      border: 1px solid var(--disabled-border-color);\n      background-color: transparent;\n      pointer-events: none;\n      color: var(--disabled-font-color);\n    }\n  }\n\n  &.danger{\n    border: 1px solid var(--danger-color-main);\n    background-color: var(--danger-color-main);\n\n    &:hover{\n      background-color: var(--danger-color-dark);\n      border: 1px solid var(--danger-color-dark);\n    }\n\n    &:disabled, &.disabled{\n      border: 1px solid var(--danger-color-disabled);\n      background-color: var(--danger-color-disabled);\n      pointer-events: none;\n    }\n  }\n\n  &.danger-border{\n    color: var(--danger-color-main);\n    border: 1px solid var(--danger-color-main);\n    background-color: transparent;\n\n    &:hover{\n      color: var(--white-color-light);\n      background-color: var(--danger-color-main);\n    }\n\n    &:disabled, &.disabled{\n      border: 1px solid var(--disabled-border-color);\n      background-color: transparent;\n      pointer-events: none;\n      color: var(--disabled-font-color);\n    }\n  }\n\n  &.warning{\n    border: 1px solid var(--warning-color-main);\n    background-color: var(--warning-color-main);\n\n    &:hover{\n      background-color: var(--warning-color-dark);\n      border: 1px solid var(--warning-color-dark);\n    }\n\n    &:disabled, &.disabled{\n      border: 1px solid var(--warning-color-disabled);\n      background-color: var(--warning-color-disabled);\n      pointer-events: none;\n    }\n  }\n\n  &.warning-border{\n    color: var(--warning-color-main);\n    border: 1px solid var(--warning-color-main);\n    background-color: transparent;\n\n    &:hover{\n      color: var(--white-color-light);\n      background-color: var(--warning-color-main);\n    }\n\n    &:disabled, &.disabled{\n      border: 1px solid var(--warning-color-disabled);\n      pointer-events: none;\n    }\n  }\n\n  &.success{\n    border: 1px solid var(--success-color-main);\n    background-color: var(--success-color-main);\n\n    &:hover{\n      background-color: var(--success-color-dark);\n      border: 1px solid var(--success-color-dark);\n    }\n\n    &:disabled, &.disabled{\n      border: 1px solid var(--success-color-disabled);\n      background-color: var(--success-color-disabled);\n      pointer-events: none;\n    }\n  }\n\n  &.success-border{\n    color: var(--success-color-main);\n    border: 1px solid var(--success-color-main);\n    background-color: transparent;\n\n    &:hover{\n      color: var(--white-color-light);\n      background-color: var(--success-color-main);\n    }\n\n    &:disabled, &.disabled{\n      border: 1px solid var(--success-color-disabled);\n      pointer-events: none;\n    }\n  }\n\n  &.white{\n    color: var(--font_active_color);\n    border: 1px solid var(--white-color-lightest);\n    background-color: var(--white-color-lightest);\n\n    &:hover{\n      background-color: var(--white-color-light);\n      border: 1px solid var(--white-color-light);\n    }\n  }\n\n  &.white-border{\n    color: var(--font_active_color);\n    border: 1px solid var(--white-color-lightest);\n    background-color: transparent;\n\n    &:hover{\n      background-color: var(--dark-color-dark-transparent-10);\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
